import { AxiosAdapter } from '../commons/adapters';
import { QueryPagination } from 'commons/interfaces';
import { buildQuery } from 'commons/utils/helpers';

const endPoint = '/v1/services-ia-credit-transactions';
const Http = new AxiosAdapter();

export const getAllServicesIaCreditTransactions = async (query?: QueryPagination) => {
  try {
    return await Http.get<any>(`${endPoint}?${buildQuery(query)}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getAllServicesIaCreditTransactions error', error);
  }
};

export const getServicesIaCreditTransactionById = async (id: string) => {
  try {
    return await Http.get<any>(`${endPoint}/${id}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getServicesIaCreditTransactionById error', error);
  }
};
